import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {PermissionAssigneeTargetLinkContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';
import {ApiVisa, BasicApiResponseModel} from "../shared";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TenantPermissionAssigneeTargetService extends BaseApiTemplateService<PermissionAssigneeTargetLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';
    this.httpClient = http;
  }

  deleteMultiple(guids: string[], apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/permission-assignee-target/multiple/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/permission-assignee-target/multiple/backoffice-ep';
    }
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';
    const options = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code
      }),
      body: guids,
    };

    return this.httpClient.delete<BasicApiResponseModel<any>>(apiUrl, options);
  }
}
